module.exports = "/remote-dist/55b8235c3a81270f4b148271dd3c84d2.png";